<div *ngIf="initialized">
  <div [id]="playerId"></div>
</div>
